import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from '@tanstack/react-query';
import { ListTree } from 'lucide-react';
import { DataTable, EmptyState, PageHeader } from '@/components/ui';
import { api } from '@/lib/api';
export function BOMsPage() {
    const list = useQuery({
        queryKey: ['boms'],
        queryFn: async () => (await api.get('/manufacturing/boms/')).data,
    });
    return (_jsxs("div", { className: "space-y-6", children: [_jsx(PageHeader, { title: "Bills of materials", description: "Recipes for finished goods. Components are consumed by work orders." }), _jsx(DataTable, { rows: list.data, loading: list.isLoading, rowKey: (r) => r.id, empty: _jsx(EmptyState, { icon: _jsx(ListTree, { className: "h-6 w-6" }), title: "No BOMs defined yet", description: "Create a BOM to describe what goes into a finished product." }), columns: [
                    { key: 'code', header: 'Code', render: (b) => _jsx("code", { className: "font-mono", children: b.code }) },
                    { key: 'name', header: 'Name', render: (b) => _jsx("span", { className: "font-medium", children: b.name }) },
                    { key: 'out', header: 'Output SKU', render: (b) => _jsx("code", { className: "font-mono", children: b.output_sku }) },
                    {
                        key: 'outQty', header: 'Output qty', align: 'right',
                        render: (b) => _jsx("span", { className: "font-mono", children: b.output_quantity }),
                    },
                    {
                        key: 'parts', header: 'Components', align: 'right',
                        render: (b) => _jsx("span", { className: "font-mono", children: b.components?.length ?? 0 }),
                    },
                    {
                        key: 'v', header: 'Version', align: 'right',
                        render: (b) => _jsxs("span", { className: "text-muted-foreground", children: ["v", b.version] }),
                    },
                ] })] }));
}
